export { default } from './RegistrationStep';
